import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiAlertCircle } from 'react-icons/fi';

const ConfirmActionModal = ({ isOpen, label, userName, onClose, onConfirm, errorMessage }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-sm overflow-hidden">
        <div className="px-6 py-5">
          <h2 className="text-base font-semibold text-gray-800 mb-2">Confirm: {label}</h2>
          <p className="text-sm text-gray-500">
            Are you sure you want to{' '}
            <span className="font-medium text-gray-700 lowercase">{label}</span> user{' '}
            <span className="font-semibold text-gray-800">{userName}</span>?
          </p>

          {errorMessage && (
            <div className="mt-4 flex items-start gap-2 bg-red-50 border border-red-100 text-red-600 rounded-lg px-3 py-2.5">
              <SafeIcon icon={FiAlertCircle} className="text-sm flex-shrink-0 mt-0.5" />
              <p className="text-xs font-medium leading-snug">{errorMessage}</p>
            </div>
          )}

          <div className="mt-6 flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-5 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 text-sm"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="px-5 py-2 text-white bg-red-500 rounded-lg hover:bg-red-600 font-medium text-sm"
            >
              {label}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmActionModal;